import React from "react";
import Typography from "@material-ui/core/Typography";
const JournalEntry = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Journal Entry
      </Typography>
      <Typography paragraph variant="h5">
        Perform manual journal entry or check auto-generated journal
      </Typography>
      <Typography paragraph variant="body1">
        Journal Entry is one of the features under the Finance module to perform
        accounting transactions particularly to manually journal entry or to
        check any accounting journal created during specific period. It contains
        any information regarding the accounting journal type, accounting
        journal document reference, currency & amount of the accounting journal,
        and the accounting journal items detail.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Accounting
        Journal Entry list. It is displayed like a table that contains download
        functions, sort, filter, and global search on the header area, and
        contains data navigation and refresh function on the footer area. The
        data column that appears in this table list are listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Accounting Journal ID</b>
        <br />
        Indicates the ID of the Accounting Journal.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Document Type</b>
        <br />
        Indicates the document type of the Accounting Journal. There are 4
        statuses: Manual Journal, Automatic Journal, Reversed, and Reversal
        Journal.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Document Reference</b>
        <br />
        Indicates the document reference of the Accounting Journal.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Document Date</b>
        <br />
        Indicates the document date of the Accounting Journal.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Currency</b>
        <br />
        Indicates the currency of the Accounting Journal.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Amount</b>
        <br />
        Indicates the amount of the Accounting Journal.
      </Typography>
      <Typography paragraph variant="body1">
        Apart from the column appearing on the table list, there are more
        columns available on each row by clicking the expand button on the left
        side of each data.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there is 1 button that appear on each row of Accounting Journal
        data with specific conditions explained below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Accounting Journal Entry Detail</b>
        <br />
        This button is used to navigate to the Accounting Journal detail in
        non-editable mode. When opening the Accounting Journal detail, there
        will be 1 button appearing on the middle section. The button is 'Reverse
        Journal' which is used to reverse the Accounting Journal data. The
        button only appear when the Accounting Journal type is 'Manual Journal'.
      </Typography>
    </React.Fragment>
  );
};

export default JournalEntry;
